// store/slices/alertSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  severity: 'info', // 'success', 'error', 'warning', 'info'
  message: '',
  autoHideDuration: 6000,
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    showAlert: (state, action) => {
      const { severity, message, autoHideDuration } = action.payload;
      state.open = true;
      state.severity = severity || 'info';
      state.message = message;
      state.autoHideDuration = autoHideDuration || 6000;
    },
    hideAlert: (state) => {
      state.open = false;
    },
    showSuccess: (state, action) => {
      state.open = true;
      state.severity = 'success';
      state.message = action.payload;
      state.autoHideDuration = 6000;
    },
    showError: (state, action) => {
      state.open = true;
      state.severity = 'error';
      state.message = action.payload;
      state.autoHideDuration = 6000;
    },
    showWarning: (state, action) => {
      state.open = true;
      state.severity = 'warning';
      state.message = action.payload;
      state.autoHideDuration = 6000;
    },
    showInfo: (state, action) => {
      state.open = true;
      state.severity = 'info';
      state.message = action.payload;
      state.autoHideDuration = 6000;
    },
  },
});

export const { showAlert, hideAlert, showSuccess, showError, showWarning, showInfo } = alertSlice.actions;

// Selectors
export const selectAlert = (state) => state.alert;

export default alertSlice.reducer;